<script setup>

</script>

<template>
  <div class="upload-file-title">
    <div class="title-left">
      <slot name="left"></slot> 
    </div> 
    <div class="title-right">
      <slot name="right"></slot>
    </div> 
  </div>
</template>

<style scoped lang='scss'>
.upload-file-title {
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #FFFFFF;
  border: 1px solid #E0E0E0;
  box-shadow: 0px 1px 8px 0px rgba(0, 0, 0, 0.05);
  padding: 0 20px;
  box-sizing: border-box;
}
</style>
